import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { PUSH_FCM_STORE, PushFcmStore, UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';
import { FCM } from '@unpispas/upp-data';
import { dataService } from '@unpispas/upp-data';
import { FeatureClientModule } from '@unpispas/feature/client';
import { FeatureProductModule } from '@unpispas/feature/product';
import { FeatureExtraModule } from '@unpispas/feature/extra';
import { FeatureOfferModule } from '@unpispas/feature/offer';
import { UppTicketPrintComponent } from '@unpispas/feature/ticket';
import { UppCashPayModalComponent } from '@unpispas/feature/ticket';
import { UppCardPayModalComponent } from '@unpispas/feature/ticket';
import { FeaturePaymentModule } from '@unpispas/feature/payment';

import { UppGuestAccessComponent } from '../components/access/upp-access';
import { UppGuestHomeComponent } from '../components/home/upp-home';
import { UppGuestReadyComponent } from '../components/ready/upp-ready';
import { UppGuestOrderComponent } from '../components/order/upp-order';
import { UppGuestPaymentComponent } from '../components/payment/upp-payment';
import { UppGuestWaiterComponent } from '../components/waiter/upp-waiter';
import { UppGuestActionComponent } from '../components/action/upp-action';
import { UppGuestReceiptComponent } from '../components/receipt/upp-receipt';
import { UppGuestRowComponent } from '../components/row/upp-row';
import { UppGuestCatalogComponent } from '../components/catalog/upp-catalog';
import { UppGuestTicketPreviewComponent } from '../components/ticket/preview/upp-preview';
import { UppGuestTicketThumbComponent } from '../components/ticket/thumb/upp-thumb';

/** Commits the guest FCM token onto `data.session.fcm` (canonical Session setter). */
export function CreatePushFcmStore(data: dataService): PushFcmStore {
  return {
    async CommitToken(token: string, lang: string): Promise<void> {
      const session = data.session;
      if (!session) {
        return;
      }

      let fcm = session.fcm;
      if (!fcm) {
        fcm = new FCM(null, data);
        fcm.lang = lang;
        fcm.token = token;
        session.fcm = fcm;
      } else {
        fcm.lang = lang;
        fcm.token = token;
      }

      if (fcm.ToInsert || fcm.ToUpdate) {
        const transaction = data.transaction;
        await transaction.push(fcm);
        await transaction.flush();
      }
    },
  };
}

@NgModule({
  declarations: [
    UppGuestAccessComponent,
    UppGuestHomeComponent,
    UppGuestReadyComponent,
    UppGuestOrderComponent,
    UppGuestPaymentComponent,
    UppGuestWaiterComponent,
    UppGuestActionComponent,
    UppGuestReceiptComponent,
    UppGuestRowComponent,
    UppGuestCatalogComponent,
    UppGuestTicketPreviewComponent,
    UppGuestTicketThumbComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    UppBaseModule,
    UppWdgtModule,
    UppDataModule,
    FeatureProductModule,
    FeatureExtraModule,
    FeatureOfferModule,
    FeatureClientModule,
    UppTicketPrintComponent,
    UppCashPayModalComponent,
    UppCardPayModalComponent,
    FeaturePaymentModule,
  ],
  exports: [
    UppGuestAccessComponent,
    UppGuestHomeComponent,
    UppGuestReadyComponent,
    UppGuestOrderComponent,
    UppGuestPaymentComponent,
    UppGuestWaiterComponent,
    UppGuestActionComponent,
    UppGuestReceiptComponent,
  ],
  providers: [{
    provide: PUSH_FCM_STORE,
    useFactory: CreatePushFcmStore,
    deps: [dataService],
  }],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class FeatureGuestModule {}
